module.exports = __webpack_public_path__ + "img/bg_audi_tablet.1b5d61c2.jpg";